import { render, staticRenderFns } from "./DeliveryOrderTimeline.vue?vue&type=template&id=64519f9e"
import script from "./DeliveryOrderTimeline.vue?vue&type=script&lang=js"
export * from "./DeliveryOrderTimeline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports